export default __webpack_public_path__ + "static/media/section_intention.08a19ee8.svg";